import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 7l2 9m-10 -9l-2 9m-1 -9h14m2 5h-18","key":"svg-0"}]]

/**
 * IconPicnicTable
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcGljbmljLXRhYmxlIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNiA3bDIgOW0tMTAgLTlsLTIgOW0tMSAtOWgxNG0yIDVoLTE4IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/picnic-table
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPicnicTable = createReactComponent('outline', 'picnic-table', 'PicnicTable', __iconNode);

export default IconPicnicTable;